import { render } from "./CalendarEmbed.vue?vue&type=template&id=39925e15&scoped=true"
import script from "./CalendarEmbed.vue?vue&type=script&lang=js"
export * from "./CalendarEmbed.vue?vue&type=script&lang=js"

import "./CalendarEmbed.vue?vue&type=style&index=0&id=39925e15&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-39925e15"

export default script